<template>
  <div class="content">
    <template>
      <v-card
        :style="
          $vuetify.breakpoint.xs
            ? 'margin: 4px'
            : 'margin: 0 18px 0 18px'
        "
      >
        <base-loading v-if="!ready" />
        <div v-if="ready">
          <crud-list
            v-model="funcionarios"
            :headers="headers"
            :slots="['item.telefones']"
            :actions="actions"
            :permission="'list_funcionario'"
            :sort-by="['nome']"
            :sort-desc="[false]"
            :export-pdf-xlsx="true"
          >
            <template
              v-if="hasPermission('inserir_funcionario')"
              v-slot:btnCadastro
            >
              <v-col>
                <v-btn
                  class="text-none text-white"
                  block
                  rounded
                  color="primary"
                  title="Cadastrar novo funcionário"
                  @click="$router.push({ path: 'funcionarios/cadastrar' })"
                >
                  <v-icon
                    dark
                    left
                  >
                    mdi-file-plus
                  </v-icon>
                  Cadastrar
                </v-btn>
              </v-col>
            </template>
            <template v-slot:[`item.telefones`]="{ item }">
              <div
                v-for="(telefone, index) in item.telefones"
                :key="index"
              >
                <span v-if="telefone">
                  {{ `${index + 1}:  ${telefone}` }}
                  <br>
                </span>
              </div>
            </template>
          </crud-list>
        </div>
      </v-card>
    </template>
  </div>
</template>
<script>
  import store from '@/store'
  import FuncionariosStore, { BOOTSTRAP, DELETE_FUNCIONARIO } from '@/store/modules/funcionarios'
  import { mapState, mapActions, mapGetters } from 'vuex'
  import { sortDateTime } from '../../utils/sorts'

  export default {
    data () {
      return {
        search: '',
        actions: [
          {
            title: 'Editar Funcionário',
            color: 'info darken-3',
            click: item => this.editarFuncionario(item),
            icon: 'mdi-pencil',
            permission: 'editar_funcionario',
          },
          {
            title: 'Excluir Funcionário',
            color: 'red darken-3',
            click: item => this.DELETE_FUNCIONARIO(item),
            icon: 'mdi-trash-can-outline',
            permission: 'excluir_funcionario',
          },
        ].filter(action => store.getters.hasPermission(action.permission)),
        headers: [
          { text: '', value: 'data-table-expand', sortable: false, groupable: false, width: '10px' },
          { text: '', value: 'actions', sortable: false, groupable: false, width: '40px' },
          { align: 'left', sortable: true, groupable: false, text: 'CPF', value: 'cpf', width: 'auto', fixed: true, report: true },
          { align: 'left', sortable: true, groupable: false, text: 'Nome', value: 'nome', width: 'auto', report: true },
          { align: 'left', sortable: false, groupable: false, text: 'Telefones', value: 'telefones', width: 'auto', report: true },
          { align: 'left', sortable: true, groupable: false, text: 'RG', value: 'rg', width: 'auto', report: true },
          { align: 'left', sortable: true, groupable: false, text: 'Email', value: 'email', width: 'auto', report: true },
          { align: 'center', sortable: true, groupable: false, text: 'Data de Nascimento', value: 'data_nascimento', width: 'auto', sort: sortDateTime, report: true },
          { align: 'left', sortable: true, groupable: true, text: 'Sexo', value: 'sexo', width: 'auto', report: true },
        ],
      }
    },
    computed: {
      ...mapState('funcionarios', ['ready', 'funcionarios']),
      ...mapGetters(['hasPermission']),
    },
    async created () {
      if (!this.$store.hasModule('funcionarios')) { this.$store.registerModule('funcionarios', FuncionariosStore) }
      this.BOOTSTRAP()
    },
    methods: {
      ...mapActions('funcionarios', [BOOTSTRAP, DELETE_FUNCIONARIO]),
      editarFuncionario ({ id }) {
        this.$router.push({
          path: `/${this.$user.get().role}/funcionarios/alterar`,
          query: { id },
        })
      },
    },
  }
</script>
